import { buttonName, formChangeEvent, formName } from '@/components/ui';
import { defineSection, Section } from '@decify/cell-shopify/client';
import './collection-main.scss';
export const collectionMainName = 'CollectionMain';
export const collectionMainTagName = 'cell-section-collection-main';
export class CollectionMain extends Section {
    domParser;
    templateCache;
    constructor() {
        super(collectionMainName);
        this.validateProps(['sectionId', 'sortBy']);
        this.domParser = new DOMParser();
        this.templateCache = new Map();
        this.handleFormChange = this.handleFormChange.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
    }
    componentDidMount() {
        this.subscribe(`${formName}.${formChangeEvent}`, this.handleFormChange);
        this.subscribe(`${buttonName}[reset-filter].click`, this.resetFilter);
    }
    async handleFormChange(data) {
        const url = new URL(window.location.href.split('?')[0]);
        for (const [key, value] of Object.entries(data)) {
            if (Array.isArray(value)) {
                for (const v of value) {
                    url.searchParams.append(key, v);
                }
            }
            else {
                url.searchParams.append(key, value);
            }
        }
        // TODO: Disable relevant actions like the select to prevent conflicts.
        const template = await this.getTemplate(url.searchParams);
        this.render(template);
        // Update the URL `sort_by` param without reloading the page. Also make sure to replace the
        // history instead of pushing a new state. Otherwise, the user will have to click the back
        // button twice to go back to the previous page.
        window.history.replaceState({}, '', url.toString());
    }
    resetFilter() {
        this.handleFormChange({
            sort_by: this.props.sortBy,
        });
    }
    async getTemplate(searchParams) {
        const queryKey = searchParams.toString();
        let template = this.templateCache.get(queryKey);
        if (!template) {
            template = await this.fetchTemplate(searchParams);
            this.templateCache.set(queryKey, template);
        }
        return template;
    }
    async fetchTemplate(searchParams) {
        // Make sure to create a copy of the URLSearchParams object to avoid modifying the original
        // which will be used to cache the template and update.
        const searchParamsCopy = new URLSearchParams(searchParams);
        searchParamsCopy.set('section_id', this.props.sectionId);
        const response = await fetch(`${window.location.pathname}?${searchParamsCopy.toString()}`);
        const responseText = await response.text();
        return this.domParser.parseFromString(responseText, 'text/html');
    }
    render(doc) {
        this.querySelectorAll('[cell-update]').forEach((element) => {
            const newElement = doc.querySelector(`[cell-update="${element.getAttribute('cell-update')}"]`);
            if (newElement) {
                element.replaceWith(newElement);
            }
        });
    }
}
defineSection(collectionMainTagName, CollectionMain);
